import React, { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { getQuestions } from '../../apiCalls/question/question';
import { sendResponse, assignRisk } from '../../apiCalls/response/response';
import { revokeToken } from '../../utils/session-utils';
import { useResult } from '../../hooks';
import { withLocal } from '../common/LocaleProvider/LocaleProvider';
import QuestionnaireSteps from './QuestionnaireSteps';
import { getMobileNumber, getUserId } from '../../utils/session-utils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  paper: {
    padding: '16px'
  },
  header: {
    margin: '16px 0px',
    fontFamily: 'times',
    color: theme.palette.primary.dark
  },
  subheader: {
    fontSize: '16px'
  },
  error: {
    color: '#e02020'
  }
}));

const Questionnaire = ({ history, locale }) => {
  const classes = useStyles();
  const mobileNumber = getMobileNumber();
  const userId = getUserId();

  const { setResult } = useResult();

  const [questions, setQuestions] = useState([]);
  const [sessionId, setSessionId] = useState(null);
  const [step, setStep] = useState(1);
  const [error, setError] = useState(null);

  useEffect(() => {
    setSessionId(uuid());
  }, []);

  useEffect(() => {
    getQuestions(
      res => setQuestions(res),
      message => setError(message)
    );
  }, []);

  const handleSendResponse = (questionId, responseText, successCallback) =>
    sendResponse(
      { questionId, mobileNumber, responseText, sessionId },
      () => successCallback(),
      message => setError(message)
    );

  const handleAssignRisk = (riskCategory, route, temp, twistleProvision) =>
    assignRisk(
      { sessionId, mobileNumber, riskCategory, userId },
      () => {
        const date = new Date().getTime();
        const payload = { cat: riskCategory, temp, date };
        setResult({ cat: riskCategory, date, temp });
        twistleProvision
          ? twistleProvision(
              { locale },
              () => {revokeToken(); history.push(route, { ...payload });  },
              err =>
                history.push(route, {
                  ...payload,
                  err
                })
            )
          : history.push(route, {
              ...payload
            });
      },
      message => setError(message)
    );

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <h1 className={classes.header}>{locale.header}</h1>
        {error && <span className={classes.error}>{error}</span>}
        <QuestionnaireSteps
          locale={locale}
          step={step}
          setStep={setStep}
          questions={questions}
          sendResponse={handleSendResponse}
          assignRisk={handleAssignRisk}
        />
      </Paper>
    </div>
  );
};

export default withLocal(Questionnaire);
